/* SOYMOD #101297 (27/4/26) - */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Comprobar que estamos en la página correcta (body con la clase específica)
  if (document.body.classList.contains('content-page-reserva-consulta')) {
    
    // 2. Buscar el enlace (botón) dentro de #MainContent
    const botonScroll = document.querySelector('#MainContent a[href="#ContactForm"]');

    if (botonScroll) {
      botonScroll.addEventListener('click', (e) => {
        e.preventDefault();

        // 3. Buscar el elemento cuyo ID empiece por ContactForm
        const formBase = document.querySelector('[id^="ContactForm"]');

        if (formBase) {
          // 4. Obtener el abuelo del formulario (parent parent)
          const targetElement = formBase.parentElement.parentElement;

          // 5. Calcular la altura del header
          const header = document.querySelector('header.header-section');
          const headerHeight = header ? header.offsetHeight : 0;

          // 6. Calcular la posición y realizar el scroll suave
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  }
});
/* End MOD */

/* SOYMOD #103478 (25/05/2026) - Descripción desplegable en móvil */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.soy_collapse_toggle');
  if (!button) return;

  var expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));

  var container = button.previousElementSibling;
  if (container && container.classList.contains('soy_collapsed')) {
    container.classList.toggle('soy_collapsed--open');
  }
});

/* End MOD */
